import { useEffect } from 'react'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { type IResponseCallTransferSucceeded } from 'entities/Call/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IEventHandlerOptions } from 'entities/Call/events/types'

export const useEventCallTransferSucceeded = (options?: IEventHandlerOptions) => {
  const { websocket, callStore } = useEntitiesContext()

  const handle = (data: IResponseCallTransferSucceeded) => {
    if (options?.enabled && !options.enabled()) return
    if (!callStore.isOwnTransferLeg(data.agent_call_sid)) return

    callStore.endTransferredCall(data.agent_call_sid)
  }

  useEffect(() => websocket.on(WebsocketEvent.CallCallTransferSucceeded, handle), [callStore])
}
